import { library, dom } from '@fortawesome/fontawesome-svg-core';

// FAS

import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons/faBookOpen';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons/faCalendarPlus';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons/faChalkboardTeacher';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faConciergeBell } from '@fortawesome/free-solid-svg-icons/faConciergeBell';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faGem } from '@fortawesome/free-solid-svg-icons/faGem';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons/faMapMarker';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons/faMicrophone';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons/faNewspaper';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faSquareFull } from '@fortawesome/free-solid-svg-icons/faSquareFull';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';

library.add(faBars);
library.add(faBookOpen);
library.add(faBullhorn);
library.add(faCalendarPlus);
library.add(faChalkboardTeacher);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCircle);
library.add(faConciergeBell);
library.add(faCopy);
library.add(faEnvelope);
library.add(faGem);
library.add(faGlobe);
library.add(faGraduationCap);
library.add(faLink);
library.add(faMapMarker);
library.add(faMicrophone);
library.add(faNewspaper);
library.add(faQuestionCircle);
library.add(faSearch);
library.add(faShoppingCart);
library.add(faSquareFull);
library.add(faStar);
library.add(faTag);
library.add(faTags);
library.add(faTimes);
library.add(faUsers);

// FAB

import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faGooglePlus } from '@fortawesome/free-brands-svg-icons/faGooglePlus';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faBitbucket } from '@fortawesome/free-brands-svg-icons/faBitbucket';
import { faBehanceSquare } from '@fortawesome/free-brands-svg-icons/faBehanceSquare';

library.add(faFacebook);
library.add(faGooglePlus);
library.add(faInstagram);
library.add(faLinkedin);
library.add(faTwitter);
library.add(faYoutube);
library.add(faBitbucket);
library.add(faGithub);
library.add(faBehanceSquare);

dom.watch();